// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithRedirect, signOut, getRedirectResult } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBG0VvqYYp93ckA0q3bcXcRmSZ9CsDuBZ8",
  authDomain: "carb-tabeta-kun.firebaseapp.com",
  projectId: "carb-tabeta-kun",
  storageBucket: "carb-tabeta-kun.firebasestorage.app",
  messagingSenderId: "341960853452",
  appId: "1:341960853452:web:2923bb03d47203b7d3bf69",
  measurementId: "G-Z5JQJY8X8Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup, signInWithRedirect, signOut, getRedirectResult };
